import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box, Button, Checkbox, FormControlLabel, Typography,
} from "@mui/material";
import surveyClosedImg from "../../assets/image/survey_thankYou2.png";

const SURVEY_CLOSED = false; // 설문 종료 시 true, 재오픈 시 false로 변경

function SurveyAgreePage() {
    const navigate = useNavigate();
    const [agreed, setAgreed] = useState(false);

    const handleStart = () => {
        sessionStorage.setItem('surveyAgreed', 'true');
        navigate('/survey/form');
    };

    if (SURVEY_CLOSED) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor:'#f0f4ff' }}>
                <img src={surveyClosedImg} alt="설문 종료" style={{ maxHeight: '100vh', maxWidth: '100%'}} />
            </Box>
        );
    }

    return (
        <Box sx={{ maxWidth: 720, mx: 'auto', px: 4, py: 6, minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>

            {/* 헤더 */}
            <Box sx={{ mb: 3, textAlign: 'center' }}>
                <Typography fontWeight="bold" sx={{ fontSize: 13, color: 'text.secondary', mb: 0.5 }}>
                    한국에너지공단
                </Typography>
                <Typography fontWeight="bold" sx={{ fontSize: 18, mb: 0.5, color: '#0029a3' }}>
                    신재생에너지 통합모니터링시스템(REMS)
                </Typography>
                <Typography fontWeight="bold" sx={{ fontSize: 22, mb: 1, color: '#3a84a6' }}>
                    원격단말장치(RTU) 현황조사 설문지
                </Typography>
                <Box sx={{ borderBottom: '2px solid #E65100', mb: 1.5 }} />
                <Typography sx={{ fontSize: 13, color: 'text.secondary' }}>
                    RTU 표준통신규격 및 보안기준 연구 과업
                </Typography>
            </Box>

            {/* 동의 내용 */}
            <Box sx={{ border: '1px solid #334475', borderRadius: 2, p: 3, mb: 2 }}>
                <Typography fontWeight="bold" sx={{ fontSize: 16, mb: 2.5, color: '#334475' }}>
                    개인정보 수집·이용 동의
                </Typography>

                <Box component="table" sx={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, mb: 2 }}>
                    <Box component="thead">
                        <Box component="tr" sx={{ backgroundColor: '#f0f4ff'}}>
                            {['수집 항목', '수집 목적', '보유 기간'].map(h => (
                                <Box key={h} component="th" sx={{ border: '1px solid #ccc', p: 1.2, fontWeight: 'bold', color: '#334475', textAlign: 'center', minWidth:'70px', wordBreak:'keep-all' }}>
                                    {h}
                                </Box>
                            ))}
                        </Box>
                    </Box>
                    <Box component="tbody">
                        <Box component="tr">
                            <Box component="td" sx={{ border: '1px solid #ccc', p: 1.2, textAlign: 'center', verticalAlign: 'middle' }}>
                                업체명<br />담당자명<br />연락처<br />이메일
                            </Box>
                            <Box component="td" sx={{ border: '1px solid #ccc', p: 1.2, textAlign: 'center', verticalAlign: 'middle' }}>
                                설문 응답자 식별, 설문 결과 분석
                            </Box>
                            <Box component="td" sx={{ border: '1px solid #ccc', p: 1.2, textAlign: 'center', verticalAlign: 'middle' }}>
                                설문 종료 후 3개월<br />(연구 과업 완료 후 즉시 파기)
                            </Box>
                        </Box>
                    </Box>
                </Box>

                <Typography sx={{ fontSize: 12, color: 'text.secondary', lineHeight: 1.8 }}>
                    위와 같이 개인정보를 수집·이용합니다. 동의를 거부할 권리가 있으며, 거부 시 참여가 제한 됩니다.
                </Typography>
            </Box>

            {/* 체크박스 */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={agreed}
                            onChange={(e) => setAgreed(e.target.checked)}
                            sx={{ color: '#334475', '&.Mui-checked': { color: '#334475' } }}
                        />
                    }
                    label={
                        <Typography fontWeight="bold" sx={{ fontSize: 15 }}>
                            개인정보 수집·이용에 동의합니다.
                        </Typography>
                    }
                />
            </Box>

            {/* 시작 버튼 */}
            <Button
                variant="contained"
                size="large"
                fullWidth
                disableElevation
                disabled={!agreed}
                onClick={handleStart}
                sx={{
                    py: 1.8,
                    fontSize: 16,
                    fontWeight: 'bold',
                    border: '1px solid transparent',
                    backgroundColor: '#334475',
                    '&:hover': { backgroundColor: '#1e2e55' },
                    '&.Mui-disabled': { border: '1px solid transparent', backgroundColor: '#ccc', color: '#fff' },
                }}
            >
                동의하고 설문 시작하기
            </Button>
        </Box>
    );
}

export default SurveyAgreePage;
